import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useAddClientSettings = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["add_settings"],
    mutationFn: async (query) => {
      return await axios.post("/settlement/settings", query);
    },
  });
};